export default __webpack_public_path__ + "static/media/ic_download.3fd08a59.svg";